import React from "react";
import SideBar from "./SideBar";
import Header from "./Header";

const Layout = ({ children }) => {
  return (
    <div className="mainLayout">
      <SideBar />
      <div className="mainContent">
        <Header />
        <div className="contentBody">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
